<div class="switch-account" [ngClass]="{ active: switchAccountOpened }">
  <div class="switch-account__active-item" (click)="toggleMenu()">
    <ng-container *ngIf="selectedAccount?.kind === '3b' && !isCIActive">
      <app-ds-rounded-icon icon="tree-deciduous" size="small" variant="custom" customColor="var(--color-core-brand-4-3)"></app-ds-rounded-icon>
      <span class="ds-heading-2">{{ 'ACCOUNT.switch.3b.title' | translate }}</span>
    </ng-container>
    <ng-container *ngIf="selectedAccount?.kind === '3a' && !isCIActive">
      <app-ds-rounded-icon icon="trees" size="small" variant="custom" customColor="var(--color-core-brand-6-2)"></app-ds-rounded-icon>
      <span class="ds-heading-2">{{ 'ACCOUNT.switch.3a.title' | translate }}</span>
    </ng-container>
    <ng-container *ngIf="selectedAccount?.kind === 'kid' && !isCIActive">
      <app-ds-rounded-icon icon="sprout" size="small" variant="custom" customColor="var(--color-core-brand-5-2)"></app-ds-rounded-icon>
      <span class="ds-heading-2">{{ selectedAccount?.owner_name }}</span>
    </ng-container>

    <ng-container *ngIf="isCIActive">
      <app-ds-rounded-icon icon="inyova" size="small" variant="custom" customColor="var(--color-core-brand-1-2)"></app-ds-rounded-icon>
      <span class="ds-heading-2">{{ 'ACCOUNT.switch.CI.title' | translate }}</span>
    </ng-container>
    <ng-container *ngIf="selectedAccount?.kind === 'grow' && !isCIActive">
      <app-ds-rounded-icon icon="earth" size="small" variant="custom" customColor="var(--color-core-brand-3-5)"></app-ds-rounded-icon>
      <span class="ds-heading-2">{{ 'ACCOUNT.switch.grow.title' | translate }}</span>
    </ng-container>
    <ion-icon class="menu-dropdown" icon="ds-chevron-down"></ion-icon>
  </div>
  <div class="switch-account__list-wrapper" [ngClass]="{ expand: switchAccountOpened }">
    <div class="switch-account__list-content">
      <ul class="switch-account__list">
        <li>
          <h4 class="ds-ui-3 ds-color-core-neutral-5">{{ 'ACCOUNT.switch.3b.title' | translate }}</h4>
          <a class="ds-heading-2" (click)="switchAccount(account3B)" [ngClass]="{ 'add-account': isNotYetCustomer(account3B) }" *ngIf="account3B">
            <div>
              <app-ds-rounded-icon
                icon="tree-deciduous"
                size="small"
                variant="custom"
                customColor="var(--color-core-brand-4-3)"
              ></app-ds-rounded-icon>
              <div>
                {{ 'ACCOUNT.switch.3b.title' | translate }}
                <div *ngIf="isNotYetCustomer(account3B)" class="ds-ui-3 ds-color-core-neutral-7">
                  <span *ngIf="account3B.step_status === stepStatus.INITIAL || account3B.step_status === stepStatus.ALMOST_PROSPECT">
                    {{ 'ACCOUNT.Y4K.cta.continuesetup' | translate }}
                  </span>
                  <span *ngIf="account3B.step_status === stepStatus.ALMOST_PROSPECT || account3B.step_status === stepStatus.PROSPECT">
                    {{ 'ACCOUNT.Y4K.cta.fundAccount' | translate }}
                  </span>
                </div>
              </div>
            </div>
          </a>
          <a class="add-account" *ngIf="!account3B" (click)="createAccount('3b')">
            <div class="ds-heading-2">
              <app-ds-rounded-icon icon="square-arrow-out-up-right" size="small" variant="custom" customColor="transparent"></app-ds-rounded-icon>
              {{ 'ACCOUNT.switch.3b.openNew' | translate }}
            </div>
          </a>
        </li>

        <ng-container *ngIf="customer?.app_location === 'ch'">
          <li>
            <h4 class="ds-ui-3 ds-color-core-neutral-5">{{ 'ACCOUNT.switch.3a.title' | translate }}</h4>
            <a class="ds-heading-2" *ngIf="account3A" (click)="switchAccount(account3A)" [ngClass]="{ 'add-account': isNotYetCustomer(account3A) }">
              <div>
                <app-ds-rounded-icon icon="trees" size="small" variant="custom" customColor="var(--color-core-brand-6-2)"></app-ds-rounded-icon>
                <div>
                  {{ 'ACCOUNT.switch.3a.title' | translate }}
                  <div *ngIf="isNotYetCustomer(account3A)" class="ds-ui-3 ds-color-core-neutral-7">
                    <span *ngIf="account3A.step_status === stepStatus.INITIAL || account3A.step_status === stepStatus.ALMOST_PROSPECT">
                      {{ 'ACCOUNT.Y4K.cta.continuesetup' | translate }}
                    </span>
                    <span *ngIf="account3A.step_status === stepStatus.PROSPECT || account3A.step_status === stepStatus.ALMOST_CUSTOMER">
                      {{ 'ACCOUNT.Y4K.cta.fundAccount' | translate }}
                    </span>
                  </div>
                </div>
              </div>
            </a>
            <a class="add-account" *ngIf="!account3A" (click)="createAccount('3a')">
              <div class="ds-heading-2">
                <app-ds-rounded-icon icon="square-arrow-out-up-right" size="small" variant="custom" customColor="transparent"></app-ds-rounded-icon>
                {{ 'ACCOUNT.switch.3a.openNew' | translate }}
              </div>
            </a>
          </li>
          <!-- GROW -->
          <li>
            <h4 class="ds-ui-3 ds-color-core-neutral-5">{{ 'ACCOUNT.switch.grow.title' | translate }}</h4>
            <a *ngIf="isAlreadyCustomer(accountGrow)" class="ds-heading-2" (click)="switchAccountToGrow()" [ngClass]="{ 'add-account': isNotYetCustomer(accountGrow) }">
              <div>
                <app-ds-rounded-icon icon="earth" size="small" variant="custom" customColor="var(--color-core-brand-3-5)"></app-ds-rounded-icon>
                {{ 'ACCOUNT.switch.grow.title' | translate }}
              </div>
            </a>
            <a class="add-account" *ngIf="isNotYetCustomer(accountGrow)" (click)="createAccount('grow')">
              <div class="ds-heading-2">
                <app-ds-rounded-icon icon="square-arrow-out-up-right" size="small" variant="custom" customColor="transparent"></app-ds-rounded-icon>
                {{ 'ACCOUNT.switch.grow.openNew' | translate }}
              </div>
            </a>
          </li>
          <!-- END GROW -->
          <li *ngIf="account3B">
            <h4 class="ds-ui-3 ds-color-core-neutral-5">{{ 'ACCOUNT.switch.kid.title-2' | translate }}</h4>
            <ng-container *ngIf="kidsAccounts?.length > 0">
              <a class="ds-heading-2 kid-account" *ngFor="let kidAccount of kidsAccounts" (click)="switchAccount(kidAccount)">
                <div>
                  <app-ds-rounded-icon icon="sprout" size="small" variant="custom" customColor="var(--color-core-brand-5-2)"></app-ds-rounded-icon>
                  <div>
                    {{ kidAccount.owner_name }}
                    <div class="ds-ui-3 ds-color-core-neutral-7">
                      <span *ngIf="kidAccount.step_status === stepStatus.INITIAL || kidAccount.step_status === stepStatus.ALMOST_PROSPECT">
                        {{ 'ACCOUNT.Y4K.cta.continuesetup' | translate }}
                      </span>
                      <span *ngIf="kidAccount.step_status === stepStatus.PROSPECT || kidAccount.step_status === stepStatus.ALMOST_CUSTOMER">
                        {{ 'ACCOUNT.Y4K.cta.fundAccount' | translate }}
                      </span>
                    </div>
                  </div>
                </div>
              </a>
            </ng-container>
            <a class="ds-heading-2 add-account" (click)="createKidsAccount()">
              <div>
                <app-ds-rounded-icon icon="square-arrow-out-up-right" size="small" variant="custom" customColor="transparent"></app-ds-rounded-icon>
                {{ 'ACCOUNT.switch.kid.openNew' | translate }}
              </div>
            </a>
          </li>
        </ng-container>
        <ng-container *ngIf="customer?.has_crowd_investor_account">
          <li>
            <h4 class="ds-ui-3 ds-color-core-neutral-5">{{ 'ACCOUNT.switch.CI.title' | translate }}</h4>
            <a class="ds-heading-2" (click)="switchAccountToCI()">
              <div>
                <app-ds-rounded-icon icon="inyova" size="small" variant="custom" customColor="var(--color-core-brand-1-2)"></app-ds-rounded-icon>
                {{ 'ACCOUNT.switch.CI.title' | translate }}
              </div>
            </a>
          </li>
        </ng-container>
      </ul>
    </div>
  </div>
</div>
